import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkHeading } from "@egds/react-core/text";
import { UitkSpacing } from "@egds/react-core/spacing";

import { JumplinksTitleProps } from "../typings";

const JumplinksTitle = (props: JumplinksTitleProps) => {
  const { model, context } = props;
  const { title } = model;
  const { location } = context.searchContext;
  const locationName = location.localizedName || location.defaultName || location.name;

  if (!(title || locationName)) {
    return null;
  }

  const { formatText } = useLocalization();

  return (
    <UitkSpacing margin={{ blockend: "two" }}>
      <div>
        <UitkHeading tag="h2" size={5}>
          {title || formatText("jumplinks.discover", locationName)}
        </UitkHeading>
      </div>
    </UitkSpacing>
  );
};

export default JumplinksTitle;
